




































import Vue from "vue";

import { getItem, removeItem } from "@/utils/Storage";

export default Vue.extend({
  name: "app-layout-minimal",
  data() {
    return {
      opened: false
    };
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
    logout(): void {
      removeItem("SESSION");
      this.$router.push({ name: "login" });
    },
    authenticated(): boolean {
      return getItem("SESSION") !== null;
    }
  }
});
